import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuHelp } from '../../../../core/api/models';
import { FileCardComponent } from '../file-card/file-card.component';

@Component({
    selector: 'app-file-card-list',
    templateUrl: './file-card-list.component.html',
    imports: [CommonModule, FileCardComponent]
})
export class FileCardListComponent {
  @Input() files: MenuHelp[] = [];
  @Output() deleteCard = new EventEmitter<number>();
  @Output() submitCard = new EventEmitter<number>();
  @Output() addCard = new EventEmitter<void>();
  @Input() service: Object;
  @Input() methodName: string;
  // Handle adding a new card
  addNewCard(): void {
    this.addCard.emit();
  }

  // Handle deleting a card
  onDeleteCard(file: any): void {
    this.deleteCard.emit(file);
  }

  // Handle submitting a card
  onSubmitCard(file: any): void {
    this.submitCard.emit(file);
  }
}
